import './FilterTitle.scss'

type FilterTitlePropsType = {
  seoHeadingElement?: string
  title: string
}

export function FilterTitle({ seoHeadingElement = 'h2', title }: FilterTitlePropsType) {
  const HeadingTag = seoHeadingElement as keyof JSX.IntrinsicElements

  return (
    title && (
      <div className="cmp-filter__title">
        <HeadingTag className="cmp-filter__title-heading h2">{title}</HeadingTag>
      </div>
    )
  )
}
